<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Controle Frota</label>
    </div>
    <tab-navegacao-controle-frota />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn v-if="isAllowed(8)" color="info" to="/controleFrota/criar" class="ma-2 white--text">
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="controleFrotas.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="controleFrotas.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(8)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { downloadLista } from "../../../services/controleFrotaService";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listacontroleFrotas",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      headers: [
        {
          text: "Id",
          align: "start",
          value: "id",
        },
        { text: "Prefixo", value: "prefixo" },
        { text: "Apelido", value: "apelido" },
        { text: "Status", value: "status" },
        { text: "Obra", value: "obra" },
        { text: "Localização", value: "localizacao" },
        { text: "HR Acumulado", value: "hr_acumulado" },
        { text: "HR Troca", value: "hr_troca" },
        { text: "HR / KM", value: "hr_km" },
        { text: "Data", value: "data" },
        { text: "Revisão a Cada", value: "revisao" },
        { text: "Equipamento", value: "equipamento" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState("controleFrota", ["controleFrotas"]),
    filteredList() {
      if (this.showAtivo === false) {
        return this.controleFrotas.filter((f) => {
          return (f.ativo === true);
        });
      } else {
        return this.controleFrotas;
      }
    },
  },
  methods: {
    ...mapActions("ControleFrota", [
      "atualizarControleFrotas",
      "atualizarControleFrota",
    ]),
    editar(controleFrota) {
      this.atualizarControleFrota(controleFrota);
      if (this.isAllowed(8)) {
        this.$router.push(`/controleFrota/editar`);
      } else {
        this.$router.push(`/controleFrota/ver`);
      }
    },
    baixarlista() {
      downloadLista();
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarControleFrotas();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacaoControleFrota: () => import('../../Tabs/TabControleFrota'),
  },
};
</script>